var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelpCentre(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#708092",
    fillRule: "evenodd",
    d: "M9.778 14.512a1 1 0 11-2 0 1 1 0 012 0M5.778 5a1 1 0 011-1h5.71C13.323 4 14 4.677 14 5.512V8c0 1.1-.9 2-2 2h-1.491a.51.51 0 00-.509.509v1.003a1 1 0 11-2 0V9.778C8 8.796 8.796 8 9.778 8h1a1 1 0 000-2h-4a1 1 0 01-1-1M17 18H3a1 1 0 01-1-1V3a1 1 0 011-1h14a1 1 0 011 1v14a1 1 0 01-1 1M0 2v16a2 2 0 002 2h16a2 2 0 002-2V2a2 2 0 00-2-2H2a2 2 0 00-2 2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpCentre);
export default __webpack_public_path__ + "static/media/help-centre.8e03d17f.svg";
export { ForwardRef as ReactComponent };